import { useTranslate } from 'react-admin';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import ShowNoteSignsItem from '@/components/common/notes/show-note-signs/show-note-signs-item';
import Box from '@mui/material/Box';
import CollapseMenu from '@/components/common/collapse-menu/collapse-menu';

interface Props {
    signs: {
        id: string;
        customFields: {
            imageDataBase64: string;
            name: string;
        };
        [key: string]: any;
    }[];
}

const ShowNoteSigns = ({ signs }: Props) => {
    const translate = useTranslate();

    return (
        <CollapseMenu defaultOpen={true} icon={<BorderColorIcon />} text={translate('app.signs')}>
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    gap: 1,
                    justifyContent: 'center',
                    p: 1,
                }}
            >
                {signs.map(({ id, customFields: { imageDataBase64, name } }) => (
                    <ShowNoteSignsItem key={id} imageDataBase64={imageDataBase64} name={name} />
                ))}
            </Box>
        </CollapseMenu>
    );
};

export default ShowNoteSigns;
